// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"3093":"list","3180":"story"}[chunkId] || chunkId) + "-" + {"361":"afa2d8d2c54cf6480163","3093":"33b2b77f21490c6cfefb","3180":"08c190a04e6f722a2781"}[chunkId] + ".css";
};